/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}.consult-menu-item-class[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]:after{content:\"\\f104\";font-family:Font Awesome\\ 4 Free;font-weight:900;margin-left:5px;animation:blinker 1s linear infinite;color:red}"];
export { styles as styles };

